<div class="mx-auto p-6 bg-white rounded-xl shadow-sm mb-8">
  <h2 class="text-3xl font-extrabold text-indigo-700 mb-6 border-b pb-2 transition-all duration-500 hover:text-indigo-800 hover:border-indigo-300">
      {{isEditMode?'Edit Property':'Add New Property'}}
  </h2>

  <div class="mb-8">
      <div class="flex justify-between text-xs font-medium text-gray-500 mb-2">
          <span class="font-bold text-indigo-600">Step {{ currentStep }} of {{ totalSteps }}</span>
          <span *ngIf="currentStep === 1" class="step-label">Basic Info</span>
          <span *ngIf="currentStep === 2" class="step-label">Price Details</span>
          <span *ngIf="currentStep === 3" class="step-label">Specifications</span>
          <span *ngIf="currentStep === 4" class="step-label">Description & Details</span>
          <span *ngIf="currentStep === 5" class="step-label">Property Images</span>
      </div>
      <div class="h-2 bg-gray-200 rounded-full overflow-hidden shadow-inner">
          <div class="h-full bg-indigo-500 transition-all duration-700 ease-in-out" [style.width.%]="(currentStep / totalSteps) * 100"></div>
      </div>
  </div>

  <form [formGroup]="propertyForm" (ngSubmit)="onSubmit()">
      <div *ngIf="currentStep === 1" class="step-content">
          <h3 class="text-xl font-semibold text-gray-800 mb-6">
              1. Basic Property Information
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
              <div class="input-group">
                  <label for="name">Property Name <span class="text-red-500">*</span></label>
                  <input formControlName="name" id="name" type="text" placeholder="e.g., Skyview Apartment" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf=" propertyForm.get('name')?.invalid && propertyForm.get('name')?.touched" class="error-message">
                      Name is required.
                  </p>
              </div>
              
              <div class="input-group">
                  <label for="address">Address<span class="text-red-500">*</span></label>
                  <input formControlName="address" id="address" type="text" placeholder="Property address" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf=" propertyForm.get('address')?.invalid && propertyForm.get('address')?.touched" class="error-message">
                      Address is required.
                  </p>
              </div>
              <div class="input-group">
                  <label for="Street_Name">Street Name<span class="text-red-500">*</span></label>
                  <input formControlName="streetName" id="Street_Name" type="text" placeholder="Street name..." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf="propertyForm.get('streetName')?.invalid && propertyForm.get('streetName')?.touched" class="error-message">
                      Street is required.
                  </p>
              </div>
                <div class="input-group">
                    <!-- {{propertyForm.value.microMarket | json}} -->
                    <label for="microMarket" class="text-sm font-semibold text-gray-700 ml-1">Micro Market Name</label>
                    <div class="relative">
                        <select formControlName="microMarket" id="microMarket" [compareWith]="compareMicroMarket" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                            <option [ngValue]="null" disabled selected>Select micro market</option>
                            <option *ngFor="let type of microMarketList" [ngValue]="type" class="py-2">
                                {{ type.micromarketName }}
                            </option>
                        </select>
                       
                        
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                    <p *ngIf="propertyForm.get('microMarket')?.valid && propertyForm.value.microMarket" class="text-xs mt-1 ml-2">
                        {{propertyForm.value.microMarket ? propertyForm.value.microMarket.cluster : ''}}
                    </p>
                    <p *ngIf="propertyForm.get('microMarket')?.invalid && propertyForm.get('microMarket')?.touched" class="text-xs text-red-500 mt-1 ml-1">
                        Micro Market is required.
                    </p>
                </div>
              <div class="input-group">
                  <label for="cityName">City Name<span class="text-red-500">*</span></label>
                  <input formControlName="cityName" id="cityName" type="text" placeholder="City name..." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf="propertyForm.get('cityName')?.invalid && propertyForm.get('cityName')?.touched" class="error-message">
                      City is required.
                  </p>
              </div>
              <div class="input-group">
                  <label for="stateName">State Name<span class="text-red-500">*</span></label>
                  <input formControlName="stateName" id="stateName" type="text" placeholder="State name..." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf="propertyForm.get('stateName')?.invalid && propertyForm.get('stateName')?.touched" class="error-message">
                      State is required.
                  </p>
              </div>
              <div class="input-group">
                  <label for="pinCode">Pin code<span class="text-red-500">*</span></label>
                  <input formControlName="pinCode" id="pinCode" type="number" placeholder="Pin code..." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  <p *ngIf=" propertyForm.get('pinCode')?.invalid && propertyForm.get('pinCode')?.touched" class="error-message">
                      Pin code is required.
                  </p>
              </div>
              <div class="input-group">
                  <label for="cord-input" class="block mb-2.5 text-sm font-medium text-heading">Google Map Link</label>
                  <div class="relative">
                      <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                          <svg class="w-4 h-4 text-body" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z" />
                          </svg>
                      </div>
                      <input formControlName="location" type="text" id="cord-input" aria-describedby="helper-text-explanation" class="block w-full ps-9 pe-3 py-2.5 bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand shadow-xs placeholder:text-body" placeholder="link" />
                      <p *ngIf=" propertyForm.get('location')?.invalid && propertyForm.get('location')?.touched" class="error-message">
                          Location link is required.
                      </p>
                  </div>
              </div>
              <div class="input-group">
                  <div class="flex flex-col w-full">
                      <label for="ageOfProperty" class="text-sm font-semibold text-gray-700 ml-1">
                          Age of Property <span class="text-red-500 ml-0.5">*</span>
                      </label>

                      <div class="relative">
                          <select formControlName="ageOfProperty" id="ageOfProperty" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                              <option value="" disabled selected>
                                  Select age of property
                              </option>
                              <option *ngFor="let age of ageOfPropertyList" [value]="age" class="py-2">
                                  {{ age }}
                              </option>
                          </select>

                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                              </svg>
                          </div>
                      </div>
                  </div>
                  <p *ngIf=" propertyForm.get('ageOfProperty')?.invalid && propertyForm.get('ageOfProperty')?.touched " class="error-message">
                      Age of Property is required.
                  </p>
              </div>
              <div class="input-group">
                  <div class="flex flex-col w-full">
                      <label for="communityCategory" class="text-sm font-semibold text-gray-700 ml-1">
                          Community Category <span class="text-red-500 ml-0.5">*</span>
                      </label>

                      <div class="relative">
                          <select formControlName="communityCategory" id="communityCategory" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                              <option value="" disabled selected>
                                  Select Community Category
                              </option>
                              <option *ngFor="let category of communityCategory" [value]="category" class="py-2">
                                  {{ category }}
                              </option>
                          </select>

                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                              </svg>
                          </div>
                      </div>
                  </div>
                  <p *ngIf=" propertyForm.get('communityCategory')?.invalid && propertyForm.get('communityCategory')?.touched " class="error-message">
                      Community Category is required.
                  </p>
              </div>

            

            <div class="input-group">
                <label for="sellerProfile">Seller Profile <span class="text-red-500">*</span></label>
                <div class="relative">
                    <select formControlName="sellerProfile" id="sellerProfile" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                        <option value="" disabled selected>Select seller profile</option>
                        <option *ngFor="let type of sellerProfile" [value]="type" class="py-2">
                            {{ type }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <p *ngIf=" propertyForm.get('sellerProfile')?.invalid && propertyForm.get('sellerProfile')?.touched " class="error-message">
                    Seller Profile is required.
                </p>
            </div>
            <div class="input-group" *ngIf="propertyForm.get('sellerProfile')?.value === 'Builder / Developer'">
                <label for="builder">Builder Name <span class="text-red-500">*</span></label>
                <input formControlName="builder" id="builder" type="text" placeholder="e.g., DLF" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                <p *ngIf=" propertyForm?.get('builder')?.invalid && propertyForm?.get('builder')?.touched" class="error-message">
                    Builder is required.
                </p>
            </div>

            <div *ngFor="let key of dropdownKeys" class="relative">
                
                <label class="text-sm font-semibold text-gray-700 ml-1">{{ dropdowns[key].label }} <small class="text-gray-400">(Max 3)</small></label>

                <div class="relative">
                <div (click)="toggleDdown(key)" class="w-full flex flex-wrap items-center gap-2 p-2 bg-white border border-gray-300 rounded-lg cursor-pointer pr-10 min-h-[42px] shadow-sm">

                    <span *ngIf="propertyForm.value[key].length === 0" class="text-gray-400">
                        {{ dropdowns[key].placeholder }}
                    </span>

                    <span *ngIf="propertyForm.value[key].length" class="bg-indigo-50 text-indigo-700 px-2.5 py-1 rounded-lg text-xs font-bold">
                        {{ propertyForm.value[key][0] }}
                    </span>

                    <span *ngIf="propertyForm.value[key].length > 1" class="bg-indigo-50 text-indigo-700 px-2.5 py-1 rounded-lg text-xs font-bold">
                    +{{ propertyForm.value[key].length - 1 }} more
                    </span>

                    <div class="absolute inset-y-0 right-0 top-1/2 -translate-y-1/2 flex items-center pr-3 pointer-events-none text-gray-400 transition-transform">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" [class.rotate-180]="isOpens(key)">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>

                <div *ngIf="isOpens(key)" class="absolute z-50 mt-2 w-full bg-white border rounded-xl shadow-xl max-h-60 overflow-y-auto">
                    <label *ngFor="let item of dropdowns[key].options" class="flex items-center gap-2 px-3 py-2 cursor-pointer" [class.bg-indigo-50]="isSelected(item, key)">
                        <input type="checkbox" 
                        [checked]="isSelected(item, key)" 
                        [disabled]="!isSelected(item, key) && propertyForm.value[key].length >= MAX_SELECTION"
                        (change)="toggleItems(item, key)" />
                        <span [class.font-semibold]="isSelected(item, key)">{{ item }}</span>
                    </label>
                </div>

                </div>
            </div>
            
            <div *ngIf="openDropdown" class="fixed inset-0 z-40" (click)="openDropdown = null"></div>
              <div class="input-group">
                  <label for="type">Listing type<span class="text-red-500">*</span></label>
                  <div class="relative">
                      <select formControlName="type" id="type" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                          <option value="" disabled selected>Select listing type</option>
                          <option *ngFor="let list of listingTypes" [value]="list" class="py-2">
                              {{ list }}
                          </option>
                      </select>
                      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                          </svg>
                      </div>
                  </div>
                  <p *ngIf="
            propertyForm.get('type')?.invalid &&
            propertyForm.get('type')?.touched
          " class="error-message">
                      Type is required.
                  </p>
              </div>
              
              <!-- <div class="flex space-x-6 pt-2">
                  <div class="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.02]">
                      <input formControlName="isLiked" id="isLiked" type="checkbox" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                      <label for="isLiked" class="ml-2 block text-sm text-gray-700 group-hover:text-indigo-600 transition-colors">Set as Featured/Liked</label>
                  </div>
                  </div> -->
                <div class="flex space-x-6 pt-2">
                    <div class="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.02]">
                        <input formControlName="isPropertyVerified" id="isPropertyVerified" type="checkbox" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                        <label for="isPropertyVerified" class="ml-2 block text-sm text-gray-700 group-hover:text-indigo-600 transition-colors">Legal Verified</label>
                    </div>
                </div>
                <div class="flex space-x-6 pt-2">
                    <div class="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.02]">
                        <input formControlName="isExclusive" id="isExclusive" type="checkbox" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                        <label for="isExclusive" class="ml-2 block text-sm text-gray-700 group-hover:text-indigo-600 transition-colors">Exclusive</label>
                    </div>
                </div>
                <div class="flex space-x-6 pt-2">
                    <div class="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.02]">
                        <input formControlName="isHighDemand" id="isHighDemand" type="checkbox" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                        <label for="isHighDemand" class="ml-2 block text-sm text-gray-700 group-hover:text-indigo-600 transition-colors">High Demand</label>
                    </div>
                </div>
                <div class="flex space-x-6 pt-2">
                    <div class="flex items-center group cursor-pointer transition-transform duration-300 hover:scale-[1.02]">
                        <input formControlName="isInvestmentGrade" id="isInvestmentGrade" type="checkbox" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                        <label for="isInvestmentGrade" class="ml-2 block text-sm text-gray-700 group-hover:text-indigo-600 transition-colors">Investment-Grade</label>
                    </div>
                </div>
          </div>         
      </div>
      <div *ngIf="currentStep === 2" class="step-content">
        <h3 class="text-xl font-semibold text-gray-800 mb-6">
            2. Property Price Details
        </h3>
         
        <div class="md:col-span-4">
            <div *ngIf="propertyForm.get('propertyType')?.value == 'Apartment'" class="flex items-center justify-between mb-2 ">
                <h3 class="text-lg font-bold text-gray-800">Pricing Details</h3>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-[30%_70%] gap-2">
                <div class="relative">
                    <div class="input-group mb-4">
                        <label for="propertyType">Property Type (Primary Classification) <span class="text-red-500">*</span></label>
                        <div class="relative">
                            <select formControlName="propertyType" id="propertyType" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                                <option value="" disabled selected>Select property type</option>
                                <option *ngFor="let type of propertyTypes" [value]="type" class="py-2">
                                    {{ type }}
                                </option>
                            </select>
                            <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>
                        <p *ngIf=" propertyForm.get('propertyType')?.invalid && propertyForm.get('propertyType')?.touched " class="error-message">
                            Property Type is required.
                        </p>
                    </div>
                </div>
                <div class="relative py-6 px-8">
                    <button type="button" (click)="addNewRow()" 
                    class="flex items-center gap-2 px-2 py-1 h-[36px] bg-white hover:bg-black text-black hover:text-white border border-gray-400 text-sm font-semibold rounded-md transition-all active:scale-95 float-right ">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Add BHK Type
                  </button>
                </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-1 gap-2">
                <div formArrayName="price" class="space-y-6">
                    <div *ngFor="let row of pricingRows.controls; let i = index" [formGroupName]="i" 
                      class="relative group bg-slate-50/50 p-4 md:p-0 md:bg-transparent rounded-2xl border border-slate-100 md:border-0 transition-all">
                      <div class="flex items-center justify-between mb-4 md:hidden">
                        <span class="text-xs font-black text-indigo-600 uppercase tracking-widest">Configuration #{{i + 1}}</span>
                        <button *ngIf="pricingRows.length > 1" type="button" (click)="removeRow(i)" class="text-red-500 p-1">
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                        </button>
                      </div>
                  
                      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-[1.2fr_1fr_1.2fr_1.2fr_1.2fr_auto] gap-4 items-end">
                        <div class="flex flex-col space-y-1.5">
                            <label class="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1">Unit Type <span class="text-red-500">*</span></label>
                            <div class="relative">
                              <select formControlName="propertyStructureType" 
                                class="w-full appearance-none bg-white border border-gray-300 rounded-xl px-4 py-3 pr-10 text-sm cursor-pointer transition-all hover:border-indigo-300 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none">
                                <option *ngFor="let type of propertyStructureType" [value]="type">{{ type }}</option>
                              </select>
                              <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                              </div>
                            </div>
                          </div>
                        <!-- BHK Type column — hidden for Plot -->
                        <div class="flex flex-col space-y-1.5"
                        *ngIf="propertyForm.get('propertyType')?.value !== 'Plot / Independent House'">
                        <label class="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1">BHK Type</label>
                        <div class="relative">
                        <select formControlName="bhkType"
                         class="w-full appearance-none bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none transition-all cursor-pointer">
                         <option value="" disabled>Select BHK</option>
                         <option *ngFor="let type of bedRoomsCounts" [value]="type">{{ type }}</option>
                        </select>
                        <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
                         <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                         </svg>
                        </div>
                        </div>
                        </div>
                  
                        <div class="flex flex-col space-y-1.5">
                          <label class="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1">Area (Sqft)</label>
                          <input type="text" formControlName="areaInSq" appNumberFormat placeholder="0.00" 
                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none transition-all" />
                        </div>
                        
                        <div class="flex flex-col space-y-1.5">
                          <label class="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1">Total Price</label>
                          <div class="relative">
                            <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm">₹</span>
                            <input type="text" formControlName="price" appNumberFormat placeholder="0.00" 
                              class="w-full pl-8 pr-4 py-3 bg-white border border-gray-200 rounded-xl text-sm font-semibold text-indigo-700 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none transition-all" />
                          </div>
                        </div>

                        <div class="flex flex-col space-y-1.5">
                          <label class="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1">Rate (₹ / per sq ft) <span class="text-red-500">*</span></label>
                          <div class="relative">
                            <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm">₹</span>
                            <span class="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-bold text-gray-400 uppercase">/ft²</span>
                            <input formControlName="averagePrice" type="text" appNumberFormat placeholder="0"
                              class="w-full pl-8 pr-12 py-3 bg-white border border-gray-200 rounded-xl text-sm focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none transition-all" />
                          </div>
                        </div>
                  
                        
                        <div class="hidden md:block">
                          <button *ngIf="pricingRows.length > 1" type="button" (click)="removeRow(i)"
                            class="p-3 text-gray-300 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all group-hover:text-gray-400">
                            <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                  
                      </div>
                  
                      <div *ngIf="row.touched && row.invalid" class="mt-2 ml-1 text-[10px] text-red-500 font-bold uppercase tracking-tight">
                        Please complete all required fields for this configuration.
                      </div>
                    </div>
                  </div>
              </div>
              <div class="mt-8 p-6 border-t border-gray-100 flex justify-end">
                 <div class="text-right">
                   <p class="text-xs text-gray-400">Total Variants</p>
                   <p class="text-lg font-bold text-gray-800">{{ pricingRows.length }} Configurations</p>
                 </div>
              </div>
        </div>
        </div>
      <div *ngIf="currentStep === 3" class="step-content">
          <h3 class="text-xl font-semibold text-gray-800 mb-6">
              3. Technical Specifications
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
              <div class="input-group">
                  <label for="landArea">Land Area (sq ft) <span class="text-red-500">*</span></label>
                  <div class="relative">
                      <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                          sq ft.
                      </div>
                      <input formControlName="landArea" id="landArea" type="text" appNumberFormat min="1" placeholder="e.g., 1200" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  </div>
                  <p *ngIf="
            propertyForm.get('landArea')?.invalid &&
            propertyForm.get('landArea')?.touched
          " class="error-message">
                      Required.
                  </p>
              </div>
              <div class="input-group">
                  <label for="superBuiltUpArea">Super Built-Up Area (sq ft)
                      <span class="text-red-500">*</span></label>
                  <div class="relative">
                      <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                          sq ft.
                      </div>
                      <input formControlName="superBuiltUpArea" id="superBuiltUpArea" type="text" appNumberFormat min="1" placeholder="e.g., 1500" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
                  </div>
                  <p *ngIf="
            propertyForm.get('superBuiltUpArea')?.invalid &&
            propertyForm.get('superBuiltUpArea')?.touched
          " class="error-message">
                      Required.
                  </p>
              </div>

              <div class="input-group">
                  <label for="possession">Possession Status <span class="text-red-500">*</span></label>
                  <div class="relative">
                      <select formControlName="possession" id="possession" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                          <option value="" disabled selected>
                              Select possession status
                          </option>
                          <option *ngFor="let option of possessionStatus" [value]="option" class="py-2">
                              {{ option }}
                          </option>
                      </select>
                      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="input-group">
                  <label for="possessionYear">Possession Year<span class="text-red-500">*</span></label>
                  <div class="relative">
                      <select formControlName="possessionYear" id="possessionYear" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                          <option value="" disabled selected>Select Possession Year</option>
                          <option *ngFor="let year of possessionYear" [value]="year" class="py-2">
                              {{ year }}
                          </option>
                      </select>
                      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                          </svg>
                      </div>
                      <p *ngIf="
              propertyForm.get('possessionYear')?.invalid &&
              propertyForm.get('possessionYear')?.touched
            " class="error-message">
                          Required.
                      </p>
                  </div>
              </div>
              <div class="relative">
                <label class="text-sm font-semibold text-gray-700 mb-1 block">
                    Structure Type <span class="text-red-500">*</span>
                </label>

                <div
                    class="flex items-center w-full bg-white border border-gray-300
                        rounded-xl overflow-hidden shadow-sm
                        focus-within:ring-4 focus-within:ring-indigo-500/10
                        focus-within:border-indigo-500 transition-all">
                    <select
                    formControlName="basementCount"
                    class="appearance-none bg-transparent px-3 py-3 text-sm
                            border-r border-gray-200 cursor-pointer focus:outline-none">
                    <option value="" disabled>Select</option>
                    <option value="0">0</option>
                    <option value="1B">1B</option>
                    <option value="2B">2B</option>
                    <option value="3B">3B</option>
                    <option value="4B">4B</option>
                    </select>

                    <!-- G + label -->
                    <span class="px-3 text-gray-500 text-sm font-medium">
                    G +
                    </span>

                    <!-- Floor input -->
                    <input
                    type="number"
                    min="0"
                    max="100"
                    formControlName="floorCount"
                    placeholder="Floors"
                    class="flex-1 px-3 py-3 text-sm bg-transparent
                            focus:outline-none" />
                </div>

                <p
                    *ngIf="
                    (propertyForm.get('basementCount')?.invalid ||
                    propertyForm.get('floorCount')?.invalid) &&
                    (propertyForm.get('basementCount')?.touched ||
                    propertyForm.get('floorCount')?.touched)
                    "
                    class="text-xs text-red-500 mt-1">
                    Please select basement and enter floor count (0–100).
                </p>
                </div>

              <div class="input-group">
                  <label for="facing">Facing</label>
                  <div class="relative">
                    <select formControlName="facing" id="facing" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                        <option value="" disabled selected>Select property facing</option>
                        <option *ngFor="let face of facingDir" [value]="face" class="py-2">
                            {{ face }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
              </div>
            <div class="input-group relative">
                <label for="additionalRooms" class="text-sm font-semibold text-gray-700 ml-1">
                    Additional Rooms <span class="text-red-500">*</span>
                </label>
                
                <div class="relative">
                    <div (click)="toggleDropdown()" 
                         class="w-full flex flex-wrap items-center gap-2 p-2 bg-white border border-gray-300 rounded-[8px] text-left text-sm transition-all hover:border-indigo-400 focus-within:ring-4 focus-within:ring-indigo-500/10 focus-within:border-indigo-500 cursor-pointer shadow-sm min-h-[27px] pr-10">
                        
                        <span *ngIf="propertyForm.get('additionalRooms')?.value?.length === 0" class="text-gray-400 ml-1">Select rooms</span>
            
                        <span
                              class="flex items-center gap-1.5 bg-indigo-50 text-indigo-700 px-2.5 py-1 rounded-lg text-xs font-bold border border-indigo-100 animate-in fade-in zoom-in duration-200">
                              {{ propertyForm.get('additionalRooms')?.value[0] }}
                        </span>
                        <span *ngIf="propertyForm.get('additionalRooms')?.value?.length >1"
                              class="flex items-center gap-1.5 bg-indigo-50 text-indigo-700 px-2.5 py-1 rounded-lg text-xs font-bold border border-indigo-100 animate-in fade-in zoom-in duration-200">
                              {{ '+'+(propertyForm.get('additionalRooms')?.value?.length -1)  + ' More Rooms' }}
                        </span>
            
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                            <svg class="w-5 h-5 transition-transform duration-300" [class.rotate-180]="isOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
            
                    <div *ngIf="isOpen" 
                         class="absolute z-[100] mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                        <div class="max-h-60 overflow-y-auto p-1 custom-scrollbar bg-white">
                            <label *ngFor="let item of allAdditionalRooms" 
                                   class="flex items-center gap-2 px-3 py-1 rounded-sm cursor-pointer transition-all group" 
                                   [class.bg-indigo-50]="isItemSelected(item)" style="display: flex !important;">
                                
                                <input type="checkbox" 
                                       [checked]="isItemSelected(item)" 
                                       (change)="toggleItem(item)" 
                                       class="w-4.5 h-4.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" style="height: 18px !important;" />
            
                                <span class="text-sm transition-colors" 
                                      [class.font-semibold]="isItemSelected(item)" 
                                      [class.text-indigo-900]="isItemSelected(item)" 
                                      [class.text-gray-700]="!isItemSelected(item)">
                                    {{ item }}
                                </span>
                            </label>
                        </div>
                        <div class="p-2 border-t border-gray-100 bg-gray-50 flex justify-end">
                            <button type="button" (click)="toggleDropdown()" class="text-xs font-bold text-indigo-600 px-4 py-2 hover:bg-white rounded-lg transition-all border border-indigo-100 shadow-sm">
                                Done
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="isOpen" class="fixed inset-0 z-[90]" (click)="toggleDropdown()"></div>
            </div>
              <div class="input-group">
                  <label for="furnishing">Furnishing Status <span class="text-red-500">*</span></label>
                  <div class="relative">
                    <select formControlName="furnishing" id="furnishing" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                        <option value="" disabled selected>Select Furnishing Status</option>
                        <option *ngFor="let option of furnishingStatus" [value]="option" class="py-2">
                            {{ option }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                    <p *ngIf="
            propertyForm.get('furnishing')?.invalid &&
            propertyForm.get('furnishing')?.touched
          " class="error-message">
                       Furnishing status required.
                    </p>
                </div>
              </div>
              <div class="input-group">
                  <label for="parking">Parking Availability <span class="text-red-500">*</span></label>
                  <div class="relative">
                    <select formControlName="parking" id="parking" class="w-full appearance-none bg-white border border-gray-300 text-gray-700 text-sm rounded-xl px-4 py-3 pr-10 cursor-pointer transition-all duration-300 ease-in-out hover:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:outline-none shadow-sm hover:shadow-md">
                        <option value="" disabled selected>Select Parking Availability</option>
                        <option *ngFor="let parking of parkingAvailability" [value]="parking" class="py-2">
                            {{ parking }}
                        </option>
                    </select>
                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                    <p *ngIf="
            propertyForm.get('parking')?.invalid &&
            propertyForm.get('parking')?.touched
          " class="error-message">
                       Parking is required.
                    </p>
                </div>
              </div>
              <div class="input-group" *ngIf="propertyForm.get('parkingCapacity')">
                  <label for="parkingcapacity">Parking Capacity <span class="text-red-500">*</span></label>
                  <select formControlName="parkingCapacity" id="parkingCapacity" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300">
                      <option value="" disabled>Select Parking Capacity</option>
                      <option *ngFor="let option of parkingCapacity" [value]="option">
                          {{ option }}
                      </option>
                  </select>
                  <p *ngIf="
            propertyForm.get('parkingCapacity')?.invalid &&
            propertyForm.get('parkingCapacity')?.touched
          " class="error-message">
                      Parking is required.
                  </p>
              </div>

              <div class="input-group">
                  <label for="reraNumber">RERA Number </label>
                  <input formControlName="reraNumber" id="reraNumber" type="text" placeholder="e.g., AP/12/345/2023" class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300" />
              </div>
          </div>
      </div>

      <div *ngIf="currentStep === 4" class="step-content">
          <h3 class="text-xl font-semibold text-gray-800 mb-6">
              3. Description & Additional Details
          </h3>

          <div class="input-group mb-6">
              <label for="shortDescription">Short Description (for listings)
                  <span class="text-red-500">*</span><small class="text-gray-400"> (Max 300 characters)</small></label>
              <textarea formControlName="shortDescription" id="shortDescription" maxlength="300" rows="2" placeholder="A brief summary." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300"></textarea>
          </div>

          <div class="input-group mb-6">
              <label for="description">Full Property Description <span class="text-red-500">*</span></label>
              <textarea formControlName="description" id="description" rows="4" placeholder="Detailed information." class="focus:ring-indigo-500 focus:border-indigo-500 transition-shadow duration-300"></textarea>
          </div>

          <div class="grid grid-cols-1">
              <div formGroupName="amenities" class="p-6 border border-indigo-200 rounded-xl bg-indigo-50/50 shadow-sm">
                  <h4 class="font-bold text-indigo-700 mb-2 flex items-center gap-2 text-lg">
                      <span>🏙️</span> Amenities
                  </h4>
                  <div class="grid grid-cols-2 lg:grid-cols-6 gap-y-1 gap-x-1">
                      <label *ngFor="let item of amenities" [for]="item.value" class="group flex items-center gap-3 p-2.5 rounded-lg hover:bg-white hover:shadow-md transition-all cursor-pointer border border-transparent hover:border-indigo-100 min-h-[48px]">
                          <input type="checkbox" [id]="item.value" [formControlName]="item.value" class="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 transition-colors shrink-0" />
                          <div class="flex items-center gap-2 overflow-hidden">
                              <svg class="w-5 h-5 text-indigo-500 shrink-0 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" [attr.d]="item.path"></path>
                              </svg>
                              <span class="text-[13px] font-medium text-gray-700 truncate group-hover:text-indigo-900" [title]="item.label">
                                  {{ item.label }}
                              </span>
                          </div>
                      </label>
                  </div>
              </div>
          </div>
      </div>
      <div *ngIf="currentStep === 5" class="step-content">
        <div class="max-w-4xl mx-auto p-8 mt-10 bg-white">
          <div class="mb-8 text-center">
            <h2 class="text-3xl font-extrabold text-gray-800">Media Manager</h2>
            <p class="text-gray-500 mt-2">Enhance your property listing with high-quality visuals</p>
          </div>
<fieldset [disabled]="isUploading" [attr.aria-busy]="isUploading" class="min-w-0">
          <div *ngIf="processing$ | async">
            Processing... {{ progress$ | async }}%
            <progress [value]="progress$ | async" max="100"></progress>
          </div>
        
          <div class="flex flex-wrap items-center justify-between gap-4 mb-8 p-2 bg-gray-50 rounded-xl border border-gray-100">
            <div class="flex gap-2">
              <button type="button" (click)="setUploadType('gallery')"
                [class]="uploadType === 'gallery' ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-200' : 'bg-white text-gray-600 hover:bg-gray-100'"
                class="px-5 py-2.5 rounded-lg font-semibold transition-all text-sm">
                Gallery Images
              </button>
              <button type="button" (click)="setUploadType('plan')"
                [class]="uploadType === 'plan' ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-200' : 'bg-white text-gray-600 hover:bg-gray-100'"
                class="px-5 py-2.5 rounded-lg font-semibold transition-all text-sm">
                Floor Plan
              </button>
              <button type="button" (click)="setUploadType('video')"
                [class]="uploadType === 'video' ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-200' : 'bg-white text-gray-600 hover:bg-gray-100'"
                class="px-5 py-2.5 rounded-lg font-semibold transition-all text-sm">
                Property Video
              </button>
            </div>
            <span class="text-xs font-bold px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full uppercase tracking-wider">
              {{ uploadType }} Mode
            </span>
          </div>
        
          <div 
            (dragover)="isDragging = true; $event.preventDefault()" 
            (dragleave)="isDragging = false"
            (drop)="onFileDropped($event)" 
            [class.border-indigo-500]="isDragging" 
            [class.bg-indigo-50]="isDragging"
            class="relative group border-2 border-dashed border-gray-300 rounded-2xl p-12 transition-all duration-300 text-center cursor-pointer hover:border-indigo-400">
        
            <input 
              #fileInput
              type="file" 
              class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10 "
              (change)="onFileSelected($event)" 
              [multiple]="uploadType === 'gallery'"
              [accept]="uploadType === 'video' ? 'video/*' : 'image/*'" style="height: 100% !important;" />
        
            <div class="space-y-4">
              <div class="mx-auto w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <svg *ngIf="uploadType !== 'video'" class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
                <svg *ngIf="uploadType === 'video'" class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg>
              </div>
              <div class="text-gray-600">
                <span class="font-bold text-indigo-600 hover:underline">Click to upload</span> or drag and drop
                <p class="text-xs text-gray-400 mt-1">
                  {{ uploadType === 'video' ? 'MP4, MOV (Max 50MB)' : 'PNG, JPG or WEBP (Max 5MB)' }}
                </p>
              </div>
            </div>
          </div>
        
          <div *ngIf="previews.length > 0" class="mt-10">
            <div class="flex items-center justify-between mb-4">
              <h4 class="text-lg font-bold text-gray-700 uppercase text-xs tracking-widest">Selected Media</h4>
              <button (click)="clearAll()" class="text-xs text-red-500 hover:font-bold transition-all">REMOVE ALL</button>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" *ngIf="previews.length > 0">
                <div *ngFor="let media of previews; let i = index" 
                     class="relative group aspect-square rounded-xl overflow-hidden border border-gray-200 bg-black shadow-md">
                  
                  <video *ngIf="media.type === 'video'" 
                         [src]="media.url" 
                         class="w-full h-full object-cover" 
                         controls 
                         muted>
                  </video>
              
                  <img *ngIf="media.type === 'gallery'" 
                       [src]="media.url" 
                       class="w-full h-full object-cover transition-transform group-hover:scale-105" />
              
                  <img *ngIf="media.type === 'plan'" 
                       [src]="media.url" 
                       class="w-full h-full object-cover transition-transform group-hover:scale-105" />
              
                  <div class="absolute flex flex-col inset-0 bg-black/40 opacity-0 group-hover:opacity-100 justify-between transition-opacity flex items-center justify-center">
                    <label class="flex items-center gap-2 text-white text-sm bg-black/50 px-3 py-1 mb-4 rounded cursor-pointer">
                        <input 
                        type="checkbox"
                        class="accent-purple-500 w-4 h-4"
                        />
                        Mark as Cover
                    </label>
                    <button type="button" (click)="removeImage(i)" 
                            class="bg-red-500 text-white p-2 rounded-full hover:scale-110 transition-transform">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-4v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
          </div>
          <div class="mt-10 pt-6 border-t border-gray-100 flex justify-end">
            <button type="button" (click)="uploadImages()" [disabled]="isUploading || selectedFiles.length === 0"
              class="px-10 py-3 bg-indigo-600 text-white font-bold rounded-xl shadow-lg hover:bg-indigo-700 disabled:bg-gray-300 disabled:shadow-none transition-all transform active:scale-95">
              <span *ngIf="isUploading" class="inline-block h-4 w-4 mr-2 align-middle rounded-full border-2 border-white/40 border-t-white animate-spin" aria-hidden="true"></span>
              <span>{{ isUploading ? 'Uploading…' : 'Upload ' + (uploadType === 'gallery' ? 'Gallery' : uploadType === 'plan' ? 'Floor Plan' : 'Video') }}</span>
            </button>
          </div>
</fieldset>
<div *ngIf="isUploading" role="status" aria-live="polite" class="mt-4 flex items-center gap-3 text-sm font-medium text-indigo-700">
  <span class="inline-block h-5 w-5 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" aria-hidden="true"></span>
  Uploading your media. Please wait…
</div>
        </div>
         

          
      </div>
      <div class="mt-8 pt-6 border-t border-gray-200 flex justify-between">
          <div class="flex gap-2">
            <button *ngIf="isEditMode" class="flex items-center px-4 py-2 gap-2 text-sm font-medium rounded-md bg-white border border-red-300 text-red-500 hover:bg-red-500 hover:text-white rounded-lg transition-all duration-300 transform hover:shadow-md hover:-translate-x-0.5">
                Delete Property
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
            </button>
            <button type="button" (click)="prevStep()"  [disabled]="currentStep === 1" class="flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 disabled:opacity-0 transition-all duration-300 transform hover:shadow-md hover:-translate-x-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back
            </button>
          </div>

          <button type="button" *ngIf="currentStep < totalSteps" (click)="nextStep()" class="flex items-center px-6 py-2 text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:shadow-lg hover:scale-[1.02]">
              Next Step
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
          </button>

          <button type="submit" *ngIf="currentStep === totalSteps" [disabled]="propertyForm.invalid" class="flex items-center px-6 py-2 text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 transform hover:shadow-lg hover:scale-[1.02] disabled:bg-green-400">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              Submit Property
          </button>
      </div>
  </form>
</div>

<div *ngIf="showSuccessModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-x-hidden overflow-y-auto bg-gray-900 bg-opacity-60 backdrop-blur-sm transition-opacity">
  <div class="relative w-full max-w-md p-8 bg-white rounded-2xl shadow-2xl transform transition-all scale-100 animate-bounce-in">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
          <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
      </div>

      <div class="text-center">
          <h3 class="text-2xl font-bold text-gray-900 mb-2">
              Property {{isEditMode? 'Edit' :'Listed'}} Successfully!
          </h3>
          <p class="text-gray-600 mb-8">
              Your property <strong>{{ propertyForm.get("name")?.value }}</strong> has
              been added to Circled+. What would you like to do next?
          </p>
      </div>

      <div class="flex flex-col gap-3" *ngIf="isEditMode">
          <button (click)="gotoProprty()" class="w-full inline-flex justify-center items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-300">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
              </svg>
              Back to Property List
          </button>
      </div>
      <div class="flex flex-col gap-3" *ngIf="!isEditMode">
        <button (click)="resetForm()" class="w-full inline-flex justify-center items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-300">
            <svg class="w-5 h-5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            Add Another Property
        </button>
    
        <button (click)="navigateToGallery()" class="w-full flex items-center justify-center px-4 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition-all active:scale-95 shadow-lg shadow-indigo-100">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Upload Images
        </button>
    
        <button (click)="goToPropertyDetails(addPropertyDetails._id)" class="w-full flex items-center justify-center px-4 py-3 bg-slate-100 text-slate-700 font-bold rounded-xl hover:bg-slate-200 transition-all active:scale-95">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
            </svg>
            Go to Property List
        </button>
    </div>
  </div>
</div>

<div *ngIf="showUploadSuccessModal" class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-all">
    <div class="relative w-full max-w-sm p-6 bg-white rounded-2xl shadow-2xl transform transition-all animate-in zoom-in duration-300">
        <button (click)="showUploadSuccessModal = false" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
  
        <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
            <svg class="h-10 w-10 text-green-600 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
        </div>
  
        <div class="text-center mb-8">
            <h3 class="text-2xl font-bold text-gray-900 leading-tight">
                {{ uploadType === 'plan' ? 'Floor Plan' : 'Gallery Photos' }} Uploaded!
            </h3>
            <p class="text-sm text-gray-500 mt-2">
                Your images have been successfully processed and attached to the property.
            </p>
        </div>
    </div>
  </div>